var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#013983"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9385 9C19.4944 9 22.3777 11.8826 22.3779 15.4385C22.3779 16.9462 21.8574 18.3313 20.9893 19.4287L23.5811 22.0205L23.6318 22.0771C23.8717 22.3717 23.8555 22.8066 23.5811 23.0811C23.3066 23.3555 22.8717 23.3717 22.5771 23.1318L22.5205 23.0811L19.9287 20.4893C18.8313 21.3574 17.4462 21.8779 15.9385 21.8779C12.3826 21.8777 9.5 18.9944 9.5 15.4385C9.50022 11.8827 12.3827 9.00022 15.9385 9ZM15.9385 10.5C13.2111 10.5002 11.0002 12.7111 11 15.4385C11 18.166 13.211 20.3777 15.9385 20.3779C17.2839 20.3779 18.5027 19.8386 19.3936 18.9658C19.4047 18.953 19.4146 18.939 19.4268 18.9268C19.439 18.9146 19.453 18.9047 19.4658 18.8936C20.3386 18.0027 20.8779 16.7839 20.8779 15.4385C20.8777 12.711 18.666 10.5 15.9385 10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-Icon.d02ebfc12eb76f610a61a8f00f631408.svg";
export { ForwardRef as ReactComponent };